import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AppButtonComponent } from '../../shared/components/button/app-button.component';
import { AuthModalShellComponent } from '../../shared/components/auth-modal-shell/auth-modal-shell.component';
import { AuthEmailFieldComponent } from '../../shared/components/auth-email-field/auth-email-field.component';
import { Subscription } from 'rxjs';
import { UiService } from '../../core/services/ui.service';
import { UserService } from '../../core/services/user.service';
import { SnackbarService } from '../../core/services/snackbar.service';
import { EMAIL_REGEX } from '../../core/constants/validation.constants';
import { Router } from '@angular/router';

type VerifyEmailForm = {
  email: FormControl<string>;
};

@Component({
  selector: 'app-verify-email-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AppButtonComponent, AuthModalShellComponent, AuthEmailFieldComponent],
  templateUrl: './verify-email-modal.component.html',
  styleUrls: ['./verify-email-modal.component.scss'],
})
export class VerifyEmailModalComponent implements OnInit, OnDestroy {
  isVisible = false;
  form: FormGroup<VerifyEmailForm>;
  isLoading = false;
  errorMessage = '';
  private sub = new Subscription();

  constructor(
    private fb: NonNullableFormBuilder,
    private uiService: UiService,
    private userService: UserService,
    private snackbar: SnackbarService,
    private router: Router,
  ) {
    this.form = this.fb.group<VerifyEmailForm>({
      email: this.fb.control('', {
        validators: [Validators.required, Validators.pattern(EMAIL_REGEX)],
      }),
    });

    this.sub.add(this.uiService.verifyEmailModal$.subscribe((v) => (this.isVisible = v)));
  }

  ngOnInit(): void {
    this.uiService.openVerifyEmailModal();
  }

  onSubmit() {
    if (this.form.invalid) return;
    this.isLoading = true;
    this.errorMessage = '';

    const email = this.form.getRawValue().email;

    this.userService.verifyMigratedEmail(email).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.closeModal();
        this.uiService.openCreatePasswordModal(res.token);
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = err.error.error || 'Email not recognized or not eligible';
        this.snackbar.show(this.errorMessage, 'error');
      },
    });
  }

  closeModal() {
    this.uiService.closeVerifyEmailModal();
    this.router.navigate(['/course-catalog']);
  }

  openResetPassword(): void {
    this.closeModal();
    this.uiService.openResetPasswordModal();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
